import { render, staticRenderFns } from "./VanFieldCheckbox.vue?vue&type=template&id=18597690&"
import script from "./VanFieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./VanFieldCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VanFieldCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports